/**
 * Browser-visible site identity.
 *
 * `NEXT_PUBLIC_SITE_NAME` is populated in `apps/storefront/next.config.js`
 * from the root `package.json` field: `siteName`.
 */
export const siteName = process.env.NEXT_PUBLIC_SITE_NAME || "Store"

export const siteDescription = `Shop ${siteName} online.`
